const faqs = [
  {
    q: '天堂影院是否需要注册才能观看？',
    a: '不需要。天堂影院是全开放免费影视平台，无需注册、无需登录，打开网页即可直接搜索和播放您想看的电影、电视剧、综艺等所有内容。',
  },
  {
    q: '视频播放画质如何？会不会卡顿？',
    a: '全站资源支持1080P及以上高清画质，部分热门内容提供4K选项。我们部署了多线高速服务器和智能CDN调度系统，即使晚高峰时段也能保持流畅播放不缓冲。',
  },
  {
    q: '资源多久更新一次？最新电影什么时候上？',
    a: '我们保持每日同步更新，院线热门大片通常在下映后第一时间上线，热门电视剧和综艺则与播出平台同步更新，确保您不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备和浏览器？',
    a: '天堂影院全面适配 Chrome、Safari、Edge、Firefox 等主流浏览器，同时完美适配电脑、平板和手机端。支持投屏功能，可将内容投射到电视大屏观看。',
  },
  {
    q: '观看时会有广告吗？',
    a: '天堂影院承诺全站无弹窗广告、无强制视频贴片广告，为您提供干净纯粹的观影环境。我们通过优化运营成本来实现完全免费的观影服务。',
  },
  {
    q: '如何快速找到想看的影片？',
    a: '您可以使用页面顶部的搜索功能输入片名、演员或导演名称进行查找。首页也设有精选推荐、热门榜单和分类索引等多个入口，帮助您快速发现感兴趣的内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group rounded-lg bg-background-50 border border-background-200/60 hover:border-secondary-500/20 transition-all duration-200"
            >
              <summary className="flex items-center justify-between cursor-pointer px-5 py-4 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-open:text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line text-sm"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 hidden group-open:flex items-center justify-center text-secondary-400">
                  <i className="ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 pt-0">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}